import type { ReferenceType } from '@cult/domain';

export const referenceKeys = {
  all: ['reference'] as const,
  list: (type: ReferenceType) => [...referenceKeys.all, type] as const,
};
